import HundredBricksAPIError from '../../../HundredBricksAPIError';
class IncomeHistoryError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('IncomeHistoryError', ...args);
    }
}
export default IncomeHistoryError;
